/**
 * 小程序码图片直链域名归一工具。
 *
 * 背景：后端 OSSClientUtil_MinIO 的 saveEndPoint 一物两用（既是 MinIO 上传 endpoint，
 * 又是上传后拼出的对外直链前缀），当前值是 http://123.14.95.212:9000/ 这种
 * 「IP:端口 + http」形式。浏览器直接渲染会被拦截，表现为小程序码「加载失败」。
 *
 * 后端已在 XcxQrcodeServiceImpl#toPublicImgUrl 做了同样的归一；这里作为前端兜底，
 * 保证①后端未部署时页面仍可用 ②历史数据/其它入口的地址也能正常显示。
 *
 * 只替换「协议 + 主机」，保留 bucket 与对象路径；幂等（已是目标域名则原样返回）。
 */
const PUBLIC_HOST = 'https://minio.yanhuotiyu.com/';

/**
 * @param {String} rawUrl 后端返回的图片直链
 * @returns {String} 可在浏览器中展示的 https 地址；入参为空则原样返回
 */
export function normalizeQrImgUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') {
    return rawUrl;
  }
  const url = rawUrl.trim();
  try {
    // 协议相对地址 //host/bucket/path
    if (url.startsWith('//')) {
      const rest = url.substring(2);
      // 若主机本身就是目标域名，直接补协议即可，否则会出现域名重复拼接
      if (rest.startsWith('minio.yanhuotiyu.com/') || rest === 'minio.yanhuotiyu.com') {
        return 'https:' + url;
      }
      const slashIdx = rest.indexOf('/');
      if (slashIdx < 0) {
        return PUBLIC_HOST;
      }
      return PUBLIC_HOST + rest.substring(slashIdx + 1);
    }
    const schemeIdx = url.indexOf('://');
    if (schemeIdx < 0) {
      // 没有协议，视为异常数据，不处理以免造出坏链接
      return rawUrl;
    }
    const hostStart = schemeIdx + 3;
    const pathStart = url.indexOf('/', hostStart);
    if (pathStart < 0) {
      return PUBLIC_HOST;
    }
    return PUBLIC_HOST + url.substring(pathStart + 1);
  } catch (e) {
    return rawUrl;
  }
}

export default normalizeQrImgUrl;
